const HELLO_TENANT_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';

export const isHello = (cloudId?: string) => cloudId === HELLO_TENANT_ID;
